module.exports = __webpack_public_path__ + "img/user.e8c2efcc.png";